import mutation from './mutation'
import action from './action'
import getter from './getter'
export default {
  namespaced: true,
  state: {
    tracker: {
      visitor: [],
      module: '',
      start_date: '',
      end_date: ''
    },
    state: false
  },
  getters: getter,
  mutations: mutation,
  actions: action,
  modules: {}
}
